import { render, staticRenderFns } from "./ServiceRecordList.vue?vue&type=template&id=289e28e8&scoped=true"
import script from "./ServiceRecordList.vue?vue&type=script&lang=js"
export * from "./ServiceRecordList.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecordList.vue?vue&type=style&index=0&id=289e28e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e28e8",
  null
  
)

export default component.exports